import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

interface AccountAdminDrawerShiftValue {
  shiftPx: number
  setDrawerShiftPx: (px: number) => void
}

const noopSetDrawerShiftPx = () => {}

const defaultValue: AccountAdminDrawerShiftValue = {
  shiftPx: 0,
  setDrawerShiftPx: noopSetDrawerShiftPx,
}

const AccountAdminDrawerShiftContext = createContext<AccountAdminDrawerShiftValue>(defaultValue)

export function AccountAdminDrawerShiftProvider({ children }: { children: ReactNode }) {
  const [shiftPx, setShiftPx] = useState(0)
  const setDrawerShiftPx = useCallback((px: number) => {
    setShiftPx(px)
  }, [])

  const value = useMemo(
    () => ({
      shiftPx,
      setDrawerShiftPx,
    }),
    [shiftPx, setDrawerShiftPx],
  )

  return (
    <AccountAdminDrawerShiftContext.Provider value={value}>
      {children}
    </AccountAdminDrawerShiftContext.Provider>
  )
}

export function useAccountAdminDrawerShift(): AccountAdminDrawerShiftValue {
  return useContext(AccountAdminDrawerShiftContext)
}
